import { useEffect, useState, useContext } from 'react';

import { partners } from 'core/dataPartner';
import { ParamsCustomerCars, ParamsDataUsefulContacts, ParamsDataGetVirtualFencesHistory } from 'utils/typeServices';

import { Box, Typography, Skeleton } from '@mui/material';

import NavTitle from 'components/views/NavTitle';

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { ReactComponent as IcCoversTable } from 'assets/icons/ic-covers-table.svg';

import { TypographyTitle, LinkButton } from './styles';

import { ParamsDataServicesPlatform } from 'utils/typeServices';
import { DataContext } from 'providers/data';
import { ParseIcInsurers } from 'utils/parseIcInsurers';

type ParamsData = {
    dataSelectedCar?: ParamsCustomerCars;
    dataContactsUseFull?: ParamsDataUsefulContacts;
    dataGetVirtualFencesHistory?: ParamsDataGetVirtualFencesHistory;
}

const DetailsPlane = ({ dataSelectedCar, dataContactsUseFull, dataGetVirtualFencesHistory }: ParamsData) => {
    const [loading, setLoading] = useState(true);
    const [selectedCarState, setSelectedCarState] = useState<ParamsCustomerCars>();
    const [dataServicesPlatform, setDataServicesPlatform] = useState<ParamsDataServicesPlatform>();
    const { selectedCar, dataUsefulContacts } = useContext(DataContext);

    useEffect(() => {
        if (dataSelectedCar) {
            setSelectedCarState(dataSelectedCar);
            setLoading(false);
        } else {
            setLoading(true);
        }
    }, [dataSelectedCar]);

    useEffect(() => {
        if (selectedCar && dataUsefulContacts) {
            const dataServicesPlatformSelected = dataUsefulContacts.ServicosPlataforma.find(({ NR_PLATAFORMA }) => selectedCar?.NR_PLATAFORMA === NR_PLATAFORMA);
            dataServicesPlatformSelected && setDataServicesPlatform(dataServicesPlatformSelected);
        }

    }, [selectedCar, dataUsefulContacts]);

    return (
        <Box sx={{ paddingTop: '1.8rem' }}>
            <TypographyTitle>
                Detalhes do plano
            </TypographyTitle>

            <Box sx={{ paddingTop: '.8rem' }}>
                <Box sx={{
                    width: '100%',
                    display: 'flex',
                    alignItems: {
                        xs: 'start',
                        md: 'center'
                    },
                    justifyContent: 'space-between',
                    flexDirection: {
                        xs: 'column',
                        md: 'row'
                    },
                    'p': {
                        fontSize: '.9375rem'
                    },
                    'strong': {
                        fontSize: '1.125rem'
                    }
                }}>
                    <p>
                        Serviço:
                        {loading ? <Skeleton /> : <strong> {selectedCarState?.PRODUTO}</strong>}
                    </p>
                    <Box sx={{
                        width: {
                            xs: '100%',
                            md: '50%',
                        },
                        marginTop: {
                            xs: '.8rem',
                            md: '0',
                        },
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                    }}>
                        <p>
                            {loading ?
                                <Skeleton />
                                :
                                dataGetVirtualFencesHistory &&
                                <>Status:<strong style={{ color: '#97C93D' }}> Ativo</strong></>
                            }
                        </p>

                        {(selectedCarState?.NR_PORCENTAGEM_INDENIZACAO === 100 && selectedCarState.CD_PRODUTO !== 2375) &&
                            <Box sx={{ display: 'flex', alignItems: 'center', 'svg': { height: '3.75rem', width: 'auto' } }}>
                                <Typography sx={{ fontSize: '.875rem', color: '#86898B' }}>
                                    Indenização
                                    <br />
                                    Tabela FIPE
                                </Typography>
                                <IcCoversTable />
                            </Box>
                        }
                    </Box>
                </Box>
            </Box>

            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: {
                        xs: 'column',
                        md: 'row'
                    },
                    paddingTop: '2rem',
                    gap: '1rem',
                    paddingBottom: '2rem', '#title-nav': { fontSize: '1rem' }
                }}>
                <Box
                    sx={{
                        width: {
                            xs: '100%',
                            md: '50%'
                        },
                        maxWidth: {
                            xs: '100%',
                            md: '21.875rem'
                        }
                    }}>
                    <NavTitle title='Serviços adicionais' />
                    {dataContactsUseFull?.ServicosAdicionaisContatos.map(({ NomeServico, CdProduto, NrPLataforma }, index) => (
                        NrPLataforma === selectedCarState?.NR_PLATAFORMA &&
                        <LinkButton to='servicos-adicionais' key={index} state={{ CdProduto }}>
                            {NomeServico}
                            <ArrowForwardIosIcon />
                        </LinkButton>
                    ))}
                </Box>
                <Box
                    sx={{
                        width: {
                            xs: '100%',
                            md: '50%'
                        },
                        maxWidth: {
                            xs: '100%',
                            md: '21.875rem'
                        },
                        marginTop: {
                            xs: '2.25rem',
                            md: 0
                        }
                    }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'relative' }}>
                        <Box>
                            <NavTitle title='Prestador Parceiro' />
                        </Box>
                        <Box sx={{ position: 'absolute', right: '0', width: '50%', display: 'flex', justifyContent: 'flex-end', 'svg': { maxWidth: '9rem', maxHeight: '2.75rem' }, 'img': { width: 'auto', height: '3.5rem' } }}>
                            {dataServicesPlatform?.CODIGO_SEGURADORA ?
                                ParseIcInsurers(dataServicesPlatform?.CODIGO_SEGURADORA)
                                :
                                <div />
                            }
                        </Box>
                    </Box>
                    {dataServicesPlatform?.ContatosAssistencia &&
                        <LinkButton to='contato-da-seguradora'>
                            Contato Seguradora
                            <ArrowForwardIosIcon />
                        </LinkButton>
                    }
                    {!selectedCarState?.COMODATO &&
                        <LinkButton to='cobertura-do-plano'>
                            Cobertura
                            <ArrowForwardIosIcon />
                        </LinkButton>
                    }
                    {selectedCar && ((partners.indexOf(selectedCar?.CD_PESSOA_PARCEIRO) < 0) && !selectedCarState?.COMODATO) && dataServicesPlatform?.ContatosCorretor.Celular &&
                        <Box sx={{
                            marginTop: {
                                xs: '1.625rem',
                                md: '2.5rem'
                            }
                        }}>
                            <NavTitle title='Parceiro' />
                            <LinkButton to='parceiro'>
                                Contatos
                                <ArrowForwardIosIcon />
                            </LinkButton>
                        </Box>
                    }
                </Box>
            </Box>
        </Box>
    );
}

export default DetailsPlane;